import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import EAF from "../../components/Service/EAF";
import AnimatePage from "../../components/ui/AnimatePage";
import Container from "../../components/ui/Container";
import { useIntroContext } from "../../hooks/useIntroContext";




const EAFPage: React.FC = () => {
  return (

    <Container>
        <EAF />
    </Container>


  );
};

export default EAFPage;
